<template>
    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 212 256"><path d="M133.32,94.32h52.35L0,256l99.97-121.26H47.61L125.37,40.42h-52.36L119.43,0h91.65l-77.76,94.32Z"/></svg>
</template>